import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template161: Torre Eiffel (Torre Eiffel, Trocadéro, Bir-Hakeim). Todo desde backend.
// page.texts[0]=header, [1]=título portada, [2]=intro | page.sections[0..2] (imageId, title, body, sabiasQue[0]) | page.llegar | page.images (portada, paris-torre-eiffel, torre-paris, puente, buenos-aires)
const Template161 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const portadaTitle = page?.texts?.[1]?.content;
	const introText = page?.texts?.[2]?.content;

	const portadaImage = getImageSrc("portada");
	const parisTorreEiffelImage = getImageSrc("paris-torre-eiffel");

	const sections = Array.isArray(page?.sections)
		? page.sections
		: Array.isArray(page?.data?.sections)
			? page.data.sections
			: Array.isArray(page?.data?.data?.sections)
				? page.data.data.sections
				: [];
	const section0 = sections[0];
	const section1 = sections[1];
	const section2 = sections[2];
	const llegar = page?.llegar ?? page?.data?.llegar ?? page?.data?.data?.llegar;

	const torreParisImage = getImageSrc(section0?.imageId);
	const puenteImage = getImageSrc(section1?.imageId);
	const buenosAiresImage = getImageSrc(section2?.imageId);

	const actualHeaderColor = headerBackgroundColor || "#2C3E50";
	const contentColor = textColor || "#444";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: 0,
		marginTop: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 9999,
					}}
				>
					{headerText}
				</Box>
			)}

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<img
						src={portadaImage}
						alt=""
						style={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaTitle && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{portadaTitle}
						</Box>
					)}
					{parisTorreEiffelImage && (
						<img
							src={parisTorreEiffelImage}
							alt=""
							style={{
								width: isSmallScreen ? 80 : 100,
								position: "absolute",
								bottom: 60,
								left: isSmallScreen ? 15 : 20,
							}}
						/>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				{introText && (
					<Box
						component="p"
						sx={{ ...estiloP, marginBottom: "12px", marginTop: "-8px" }}
					>
						{introText}
					</Box>
				)}

				{section0 && (
					<Box data-block-id="text-2" sx={{ display: "flex", gap: "16px", position: "relative" }}>
						{torreParisImage && (
							<img
								src={torreParisImage}
								alt=""
								style={{
									width: "40%",
									height: 110,
									borderRadius: 12,
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: torreParisImage ? "60%" : "100%" }}>
							{section0.title && (
								<Box component="h3" sx={estiloH3}>
									{section0.title}
								</Box>
							)}
							{section0.body && (
								<Box component="p" sx={estiloP}>
									{section0.body}
								</Box>
							)}
						</Box>
						{section0.sabiasQue?.[0] && (
							<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
								<SabiasQue
									icono={section0.sabiasQue[0].icono}
									texto={section0.sabiasQue[0].texto}
								/>
							</Box>
						)}
					</Box>
				)}

				{section1 && (
					<Box
						data-block-id="text-3"
						sx={{
							backgroundColor: "#E8F4F8",
							padding: "12px",
							borderRadius: "12px",
							display: "flex",
							gap: "16px",
							alignItems: "center",
							position: "relative",
							marginTop: "12px",
						}}
					>
						{puenteImage && (
							<img
								src={puenteImage}
								alt=""
								style={{
									width: "35%",
									borderRadius: 12,
									objectFit: "cover",
									height: 90,
								}}
							/>
						)}
						<Box sx={{ width: puenteImage ? "65%" : "100%" }}>
							{section1.title && (
								<Box component="h3" sx={estiloH3}>
									{section1.title}
								</Box>
							)}
							{section1.body && (
								<Box component="p" sx={estiloP}>
									{section1.body}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{section2 && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: "16px",
							marginTop: "12px",
							position: "relative",
						}}
					>
						{buenosAiresImage && (
							<img
								src={buenosAiresImage}
								alt=""
								style={{
									width: "40%",
									height: 110,
									borderRadius: 12,
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: buenosAiresImage ? "60%" : "100%" }}>
							{section2.title && (
								<Box component="h3" sx={estiloH3}>
									{section2.title}
								</Box>
							)}
							{section2.body && (
								<Box component="p" sx={estiloP}>
									{section2.body}
								</Box>
							)}
						</Box>
						{section2.sabiasQue?.[0] && (
							<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
								<SabiasQue
									icono={section2.sabiasQue[0].icono}
									texto={section2.sabiasQue[0].texto}
								/>
							</Box>
						)}
					</Box>
				)}

				{llegar?.content && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#E8F4F8",
							border: "3px solid #2C3E50",
							borderRadius: "12px",
							padding: "6px",
							paddingTop: "12px",
							paddingBottom: "12px",
							fontSize: 12,
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
							color: "#333",
							marginTop: "14px",
							marginBottom: isSmallScreen ? "12px" : 0,
							paddingLeft: "0px",
							marginLeft: "0px",
						}}
					>
						<Box
							component="div"
							dangerouslySetInnerHTML={{ __html: llegar.content }}
							sx={{ paddingLeft: "20px", margin: 0, lineHeight: 1.5 }}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template161.thumbnail = "/images/template-1.png";

export default Template161;
